import React, { FunctionComponent } from 'react';

import { useTranslation } from 'react-i18next';

import 'reviews2/feed/review-yeti/reply/editor/custom-elements/NoResponseRequired.scss';

export const NoResponseRequired: FunctionComponent = () => {
    const { t } = useTranslation('reviews2');

    return (
        <div className="r4e-review-no-response-required">
            <span>{t('NO_RESPONSE_REQUIRED_WARNING')}</span>
        </div>
    );
};
